import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-4\"><div class=\"flex flex-wrap -mx-6\"><div class=\"w-full px-6 sm:w-1/2 xl:w-1/3\"><div class=\"flex items-center px-5 py-6 bg-white rounded-md shadow-sm\"><div class=\"p-3 bg-indigo-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 28 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.2 9.08889C18.2 11.5373 16.3196 13.5222 14 13.5222C11.6804 13.5222 9.79999 11.5373 9.79999 9.08889C9.79999 6.64043 11.6804 4.65556 14 4.65556C16.3196 4.65556 18.2 6.64043 18.2 9.08889Z\" fill=\"currentColor\"></path><path d=\"M25.2 12.0444C25.2 13.6768 23.9464 15 22.4 15C20.8536 15 19.6 13.6768 19.6 12.0444C19.6 10.4121 20.8536 9.08889 22.4 9.08889C23.9464 9.08889 25.2 10.4121 25.2 12.0444Z\" fill=\"currentColor\"></path><path d=\"M19.6 22.3889C19.6 19.1243 17.0927 16.4778 14 16.4778C10.9072 16.4778 8.39999 19.1243 8.39999 22.3889V26.8222H19.6V22.3889Z\" fill=\"currentColor\"></path><path d=\"M8.39999 12.0444C8.39999 13.6768 7.14639 15 5.59999 15C4.05359 15 2.79999 13.6768 2.79999 12.0444C2.79999 10.4121 4.05359 9.08889 5.59999 9.08889C7.14639 9.08889 8.39999 10.4121 8.39999 12.0444Z\" fill=\"currentColor\"></path><path d=\"M22.4 26.8222V22.3889C22.4 20.8312 22.0195 19.3671 21.351 18.0949C21.6863 18.0039 22.0378 17.9556 22.4 17.9556C24.7197 17.9556 26.6 19.9404 26.6 22.3889V26.8222H22.4Z\" fill=\"currentColor\"></path><path d=\"M6.64896 18.0949C5.98058 19.3671 5.59999 20.8312 5.59999 22.3889V26.8222H1.39999V22.3889C1.39999 19.9404 3.2804 17.9556 5.59999 17.9556C5.96219 17.9556 6.31367 18.0039 6.64896 18.0949Z\" fill=\"currentColor\"></path></svg></div><div class=\"mx-5\"><h4 class=\"text-2xl font-semibold text-gray-700\">8,282</h4><div class=\"text-gray-500\">New Users</div></div></div></div><div class=\"w-full px-6 mt-6 sm:w-1/2 xl:w-1/3 sm:mt-0\"><div class=\"flex items-center px-5 py-6 bg-white rounded-md shadow-sm\"><div class=\"p-3 bg-blue-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.19999 1.4C3.4268 1.4 2.79999 2.02681 2.79999 2.8C2.79999 3.57319 3.4268 4.2 4.19999 4.2H5.9069L6.33468 5.91114C6.33917 5.93092 6.34409 5.95055 6.34941 5.97001L8.24953 13.5705L6.99992 14.8201C5.23602 16.584 6.48528 19.6 8.97981 19.6H21C21.7731 19.6 22.4 18.9732 22.4 18.2C22.4 17.4268 21.7731 16.8 21 16.8H8.97983L10.3798 15.4H19.6C20.1303 15.4 20.615 15.1004 20.8521 14.6261L25.0521 6.22609C25.2691 5.79212 25.246 5.27673 24.991 4.86398C24.7357 4.45123 24.2852 4.2 23.8 4.2H8.79308L8.35818 2.46044C8.20238 1.83722 7.64241 1.4 6.99999 1.4H4.19999Z\" fill=\"currentColor\"></path><path d=\"M22.4 23.1C22.4 24.2598 21.4598 25.2 20.3 25.2C19.1403 25.2 18.2 24.2598 18.2 23.1C18.2 21.9402 19.1403 21 20.3 21C21.4598 21 22.4 21.9402 22.4 23.1Z\" fill=\"currentColor\"></path><path d=\"M9.1 25.2C10.2598 25.2 11.2 24.2598 11.2 23.1C11.2 21.9402 10.2598 21 9.1 21C7.9402 21 7 21.9402 7 23.1C7 24.2598 7.9402 25.2 9.1 25.2Z\" fill=\"currentColor\"></path></svg></div><div class=\"mx-5\"><h4 class=\"text-2xl font-semibold text-gray-700\">200,521</h4><div class=\"text-gray-500\">Total Orders</div></div></div></div><div class=\"w-full px-6 mt-6 sm:w-1/2 xl:w-1/3 xl:mt-0\"><div class=\"flex items-center px-5 py-6 bg-white rounded-md shadow-sm\"><div class=\"p-3 bg-pink-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.99998 11.2H21L22.4 23.8H5.59998L6.99998 11.2Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"></path><path d=\"M9.79999 8.4C9.79999 6.08041 11.6804 4.2 14 4.2C16.3196 4.2 18.2 6.08041 18.2 8.4V12.6C18.2 14.9197 16.3196 16.8 14 16.8C11.6804 16.8 9.79999 14.9197 9.79999 12.6V8.4Z\" stroke=\"currentColor\" stroke-width=\"2\"></path></svg></div><div class=\"mx-5\"><h4 class=\"text-2xl font-semibold text-gray-700\">215,542</h4><div class=\"text-gray-500\">Available Products</div></div></div></div></div></div><div class=\"mt-8\"></div>", 2)
const _hoisted_3 = { class: "flex flex-col mt-8" }
const _hoisted_4 = { class: "py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8" }
const _hoisted_5 = { class: "inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_6 = { class: "min-w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50" }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50" }, " Title "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50" }, " Role "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 border-b border-gray-200 bg-gray-50" })
  ])
], -1)
const _hoisted_8 = { class: "bg-white" }
const _hoisted_9 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 w-10 h-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-10 h-10 rounded-full",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })
], -1)
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "text-sm font-medium leading-5 text-gray-900" }
const _hoisted_14 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_15 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_16 = { class: "text-sm leading-5 text-gray-900" }
const _hoisted_17 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_18 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_19 = { class: "inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full" }
const _hoisted_20 = { class: "px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm font-medium leading-5 text-right border-b border-gray-200 whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-around" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "mx-2 px-2 rounded-md"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5 text-green-700",
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, [
          /*#__PURE__*/_createElementVNode("path", { d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" }),
          /*#__PURE__*/_createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
            "clip-rule": "evenodd"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("form", { method: "POST" }, [
        /*#__PURE__*/_createElementVNode("button", { class: "mx-2 px-2 rounded-md" }, [
          /*#__PURE__*/_createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5 text-red-700",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
              "clip-rule": "evenodd"
            })
          ])
        ])
      ])
    ])
  ])
], -1)

import { ref } from "vue";
import Banner from "../partials/Banner.vue";
import Breadcrumb from "../partials/Breadcrumb.vue";
interface User {
  name: string;
  email: string;
  title: string;
  title2: string;
  status: string;
  role: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const testUser: User = {
  name: "John Doe",
  email: "john@example.com",
  title: "Software Engineer",
  title2: "Web dev",
  status: "Active",
  role: "Owner",
};

const users = ref<User[]>([...Array(10).keys()].map(() => testUser));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: "" }),
    _createVNode(Banner),
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (u, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(u.name), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(u.email), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(u.title), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(u.title2), 1)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(u.status), 1)
                  ]),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(u.role), 1),
                  _hoisted_21
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})